
// actions
// functions that causes side effects and can involve asynchronous operations.
const actions = {
}

// // // //

export default actions



// WEBPACK FOOTER //
// ./src/store/record/actions.js